import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Content = styled.div `
  iframe {
    &[src*='youtube.com'],
    &[src*='vimeo.com'] {
      aspect-ratio: 16 / 9;
    }
  }
`;
export const IframeStyles = {
    Container,
    Content,
};
